export function disableWeekends(date) {
  let dateVal = new Date(date);
  return dateVal.getDay() === 0 || dateVal.getDay() === 6;
}
